/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniForward = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-forward ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M3.28824 4.81859C2.28891 4.20135 1 4.9202 1 6.09478V13.9053C1 15.0798 2.2889 15.7987 3.28824 15.1815L9.61101 11.2762C9.76598 11.1805 9.89564 11.0636 10 10.9325V13.9053C10 15.0798 11.2889 15.7987 12.2882 15.1815L18.611 11.2762C19.56 10.6901 19.56 9.30998 18.611 8.72382L12.2882 4.81859C11.2889 4.20135 10 4.9202 10 6.09478V9.06757C9.89564 8.93643 9.76598 8.81954 9.61101 8.72382L3.28824 4.81859Z"
        fill="#7041F1"
      />
    </svg>
  );
};
